export default (options) => ({
    swiper: null,
    currentIndex: null,
    currentDescription: null,
    
    init() {
        let eventAlreadySent = false;
        const swiperOptions = {
            loop: true,
            // Navigation arrows
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
            on: {
                init: (swiper) => {
                    //this.currentDescription = swiper.slides[swiper.realIndex]?.querySelector('img')?.getAttribute('alt');
                },
                slideChange: (swiper) => {
                    this.currentIndex = swiper.realIndex;
                    let event = event = swiper.el.dataset.onSwipeEvent;
                    if (event && !eventAlreadySent) {
                        gtag_report_event(event);
                        eventAlreadySent = true;
                    }
                    if (swiper.realIndex === swiper.slides.length - 2 && swiper.params.effect === 'creative' || swiper.realIndex === swiper.slides.length - 1) {
                        document.querySelector('.swiper-button-next').classList.add('swiper-button-disabled');
                        document.querySelector('.swiper-button-next').style.pointerEvents = 'none';
                    } else {
                        document.querySelector('.swiper-button-next').classList.remove('swiper-button-disabled');
                        document.querySelector('.swiper-button-next').style.pointerEvents = 'auto';
                    }
                }
            }
        };

        this.swiper = new Swiper(this.$refs.swiper, {
            ...swiperOptions,
            ...options
        });
    }
});
